import { Component, Input, OnInit } from '@angular/core';
import { Params, Router } from '@angular/router';
import { Record } from 'src/app/models/record';
import { RecordSwipperItem, RecordSwipperUtils, SwiperConfigType } from 'src/app/models/record-swiper';
import { Util } from 'src/app/util';

@Component({
  selector: 'resource-carousel',
  templateUrl: './resource-carousel.component.html',
  styleUrls: ['./resource-carousel.component.scss'],
})
export class ResourceCarouselComponent implements OnInit {
  @Input()
  records: Record[];

  @Input()
  resourcesOptionalCriteria: any;

  @Input()
  optionalResourcesQuery: string;

  @Input()
  levelName: string;

  swiperItems: RecordSwipperItem[] = [];

  readonly swiperType = SwiperConfigType.CAREER_PLANS;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.records.forEach((r) => this.swiperItems.push(RecordSwipperUtils.fromRecordToSwiperItem(r)));
  }

  goToResults() {
    if (this.resourcesOptionalCriteria || this.optionalResourcesQuery) {
      const params: Params = {
        limit: 24,
        offset: 0,
        order: 'fechaModifica_dt:desc',
        title: this.levelName,
        showReturnButton: true,
        hideButtonsSideMenu: true,
        originPage: '/user/career-plans'
      };

      if (this.optionalResourcesQuery == null || this.optionalResourcesQuery.trim().length === 0) {
        params.facets = this.buildFacetQueryStr(this.resourcesOptionalCriteria);
      } else {
        params.query = this.optionalResourcesQuery;
      }

      this.router.navigate(['/results'], { queryParams: params });
    }
  }

  openResourceInfo(resourceIndex: number) {
    this.router.navigate(['/info', Util.slugifyRecord(this.records[resourceIndex])]);
  }

  private buildFacetQueryStr(resourcesOptionalCriteria: Map<string, string>) {
    let facetQueryStr = '';
    const keys = Object.keys(resourcesOptionalCriteria);
    keys.forEach((k) => (facetQueryStr += `${k}:\"${resourcesOptionalCriteria[k]}\";`));
    if (facetQueryStr.length !== 0) {
      facetQueryStr = facetQueryStr.slice(0, facetQueryStr.length - 1);
    }

    return facetQueryStr;
  }
}
